import type { ReactNode } from "react";
import React from "react";
import type { ChakraProps } from "@chakra-ui/react";
import { Grid } from "@chakra-ui/react";
import { space } from "theme/themeConfig";

import { ItemContainer } from "../../../BasketLists/ProductList/ProductList.styles";

type Props = ChakraProps & {
  children: ReactNode;
  cardKey?: string;
  disableCard?: boolean;
};

export const CardContainer: React.FC<Props> = ({
  children,
  cardKey = "",
  disableCard = false,
  ...chakraProps
}) => {
  return (
    <ItemContainer>
      <Grid
        data-testid={cardKey}
        gridTemplateColumns={{ base: "1fr 3fr", sm: "100px 1fr" }}
        gap={{ base: space["1"], lg: space[2] }}
        opacity={disableCard ? 0.4 : 1}
        css={{
          "@media (max-width: 320px)": {
            gap: "0.75rem"
          }
        }}
        p={0}
        m={0}
        {...chakraProps}
      >
        {children}
      </Grid>
    </ItemContainer>
  );
};
